import React, { useEffect, useState } from 'react';
import {
  Button,
  CircularProgress,
  Container,
  TextField,
  Paper,
  Snackbar,
  Typography,
  Box,
  Grid,
  Card,
  CardContent,
  Fade,
  IconButton,
  InputAdornment
} from '@material-ui/core';
import { Alert, RolesList, Styles } from 'components/Tools';
import { 
  AccountCircle, 
  Edit, 
  Lock, 
  Save,
  ArrowBack,
  Person,
  VpnKey,
  Cancel,
  Visibility,
  VisibilityOff
} from '@material-ui/icons';
import { useFormik } from 'formik';
import { useThunkDispatch, useTypedSelector } from 'hooks';
import * as yup from 'yup';
import { changeMePassword, updateUser } from '../../redux/actions/users.actions';
import { updateMyUser } from '../../redux/actions/session.actions';

const fadeInAnimation = `
  @keyframes fadeIn {
    from {
      opacity: 0;
      transform: translateY(-20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }
`;
const validationSchemaProfile = yup.object({
  name: yup
    // @ts-ignore
    .string('Enter your username')
    .min(3, 'username should be of minimum 3 characters length')
    .max(50, 'username should be of maximun 50 characters length')
    .required('username is required'),
  lastName: yup
    // @ts-ignore
    .string('Enter your username')
    .min(3, 'username should be of minimum 3 characters length')
    .max(50, 'username should be of maximun 50 characters length')
    .required('username is required'),
});

const validationSchemaPassword = yup.object({
  password: yup
    // @ts-ignore
    .string('Enter your password')
    .max(50, 'username should be of maximun 50 characters length'),
  passwordN: yup
    // @ts-ignore
    .string('Enter your password')
    .min(6, 'debe tener al menos 6 caracteres')
    .matches(/[a-z]+/, 'Debe tener al menos una minuscula')
    .matches(/[A-Z]+/, 'Debe tener al menos una mayuscula')
    .matches(/[0-9]+/, 'Debe tener al menos un numero')
    .max(50, 'username should be of maximun 50 characters length'),
  passwordV: yup
    // @ts-ignore
    .string('Enter your password')
    .oneOf([yup.ref('passwordN'), null], 'Contraseña No Coincide')
    .max(50, 'username should be of maximun 50 characters length'),
});

const EditProfile = ({ handleActive, onBack }: { handleActive: () => void, onBack: () => void }) => {
  const classes = Styles();
  const session = useTypedSelector((s) => s.session);
  const dispatch = useThunkDispatch();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const formik = useFormik({
    initialValues: {
      name: session.user.name,
      lastName: session.user.lastName,
    },
    validationSchema: validationSchemaProfile,
    onSubmit: (values) => {
      handleActive();
      dispatch(
        updateUser(
          session.user.userName,
          {
            name: values.name,
            lastName: values.lastName,
            role: getRoleIdFromAccessLevel(session.user.role.accessLevel),
            branchOfficeId: session.user.branchOffice?.id || null,
            deviceImei: null,
          },
          handleUpdateMyProfile,
        ),
      );
    },
  });

  const handleUpdateMyProfile = (name: string, lastName: string) => {
    dispatch(updateMyUser(name, lastName));
  };

  return (
    <Fade in={mounted} timeout={300}>
      <Paper
        elevation={8}
        style={{
          padding: '32px',
          borderRadius: '16px',
          background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          maxWidth: '500px',
          margin: '0 auto',
        }}
      >
        <Box display="flex" alignItems="center" mb={3}>
          <IconButton onClick={onBack} style={{ marginRight: '16px' }}>
            <ArrowBack />
          </IconButton>
          <Box>
            <Typography variant="h5" style={{ fontWeight: 600, color: '#343c89' }}>
              Editar perfil
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Actualiza tu información personal
            </Typography>
          </Box>
        </Box>

        {session.isLoading ? (
          <Box display="flex" justifyContent="center" my={4}>
            <CircularProgress style={{ color: '#343c89' }} />
          </Box>
        ) : (
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Nombre"
                  name="name"
                  value={formik.values.name}
                  onChange={formik.handleChange}
                  error={formik.touched.name && Boolean(formik.errors.name)}
                  helperText={formik.touched.name && formik.errors.name}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Person style={{ color: '#343c89' }} />
                      </InputAdornment>
                    ),
                    style: {
                      borderRadius: '8px',
                    }
                  }}
                  style={{ marginBottom: '20px' }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Apellido"
                  name="lastName"
                  value={formik.values.lastName}
                  onChange={formik.handleChange}
                  error={formik.touched.lastName && Boolean(formik.errors.lastName)}
                  helperText={formik.touched.lastName && formik.errors.lastName}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <Person style={{ color: '#343c89' }} />
                      </InputAdornment>
                    ),
                    style: {
                      borderRadius: '8px',
                    }
                  }}
                  style={{ marginBottom: '20px' }}
                />
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="space-between" mt={2}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={onBack}
                    startIcon={<Cancel />}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    startIcon={<Save />}
                    style={{ background: '#343c89' }}
                  >
                    Guardar Cambios
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        )}
      </Paper>
    </Fade>
  );
};

const EditPassword = ({
  handleChangeSuccess,
  handleActive,
  onBack
}: {
  handleChangeSuccess: (flag: boolean) => void;
  handleActive: () => void;
  onBack: () => void;
}) => {
  const [showPassword, setShowPassword] = useState(false);
  const [showNewPassword, setShowNewPassword] = useState(false);
  const [showConfirmPassword, setShowConfirmPassword] = useState(false);

  const session = useTypedSelector((s) => s.session);
  const dispatch = useThunkDispatch();
  const [mounted, setMounted] = useState(false);

  useEffect(() => {
    setMounted(true);
  }, []);

  const formik = useFormik({
    initialValues: {
      password: '',
      passwordN: '',
      passwordV: '',
    },
    validationSchema: validationSchemaPassword,
    onSubmit: (values) => {
      handleActive();
      dispatch(
        changeMePassword(
          {
            oldPassword: values.password,
            newPassword: values.passwordN,
          },
          handleChangeSuccess,
        ),
      );
    },
  });

  return (
    <Fade in={mounted} timeout={300}>
      <Paper
        elevation={8}
        style={{
          padding: '32px',
          borderRadius: '16px',
          background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
          boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
          maxWidth: '500px',
          margin: '0 auto',
        }}
      >
        <Box display="flex" alignItems="center" mb={3}>
          <IconButton onClick={onBack} style={{ marginRight: '16px' }}>
            <ArrowBack />
          </IconButton>
          <Box>
            <Typography variant="h5" style={{ fontWeight: 600, color: '#343c89' }}>
              Cambiar contraseña
            </Typography>
            <Typography variant="body2" color="textSecondary">
              Actualiza tu contraseña de acceso
            </Typography>
          </Box>
        </Box>

        {session.isLoading ? (
          <Box display="flex" justifyContent="center" my={4}>
            <CircularProgress style={{ color: '#343c89' }} />
          </Box>
        ) : (
          <form onSubmit={formik.handleSubmit}>
            <Grid container spacing={3}>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Contraseña actual"
                  name="password"
                  type={showPassword ? 'text' : 'password'}
                  value={formik.values.password}
                  onChange={formik.handleChange}
                  error={formik.touched.password && Boolean(formik.errors.password)}
                  helperText={formik.touched.password && formik.errors.password}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <VpnKey style={{ color: '#343c89' }} />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowPassword(!showPassword)}
                          edge="end"
                        >
                          {showPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                    style: {
                      borderRadius: '8px',
                    }
                  }}
                  style={{ marginBottom: '20px' }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Nueva contraseña"
                  name="passwordN"
                  type={showNewPassword ? 'text' : 'password'}
                  value={formik.values.passwordN}
                  onChange={formik.handleChange}
                  error={formik.touched.passwordN && Boolean(formik.errors.passwordN)}
                  helperText={formik.touched.passwordN && formik.errors.passwordN}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <VpnKey style={{ color: '#343c89' }} />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowNewPassword(!showNewPassword)}
                          edge="end"
                        >
                          {showNewPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                    style: {
                      borderRadius: '8px',
                    }
                  }}
                  style={{ marginBottom: '20px' }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  fullWidth
                  variant="outlined"
                  label="Confirmar nueva contraseña"
                  name="passwordV"
                  type={showConfirmPassword ? 'text' : 'password'}
                  value={formik.values.passwordV}
                  onChange={formik.handleChange}
                  error={formik.touched.passwordV && Boolean(formik.errors.passwordV)}
                  helperText={formik.touched.passwordV && formik.errors.passwordV}
                  InputLabelProps={{
                    shrink: true,
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <VpnKey style={{ color: '#343c89' }} />
                      </InputAdornment>
                    ),
                    endAdornment: (
                      <InputAdornment position="end">
                        <IconButton
                          aria-label="toggle password visibility"
                          onClick={() => setShowConfirmPassword(!showConfirmPassword)}
                          edge="end"
                        >
                          {showConfirmPassword ? <VisibilityOff /> : <Visibility />}
                        </IconButton>
                      </InputAdornment>
                    ),
                    style: {
                      borderRadius: '8px',
                    }
                  }}
                  style={{ marginBottom: '20px' }}
                />
              </Grid>
              <Grid item xs={12}>
                <Box display="flex" justifyContent="space-between" mt={2}>
                  <Button
                    variant="outlined"
                    color="primary"
                    onClick={onBack}
                    startIcon={<Cancel />}
                  >
                    Cancelar
                  </Button>
                  <Button
                    type="submit"
                    variant="contained"
                    color="primary"
                    startIcon={<VpnKey />}
                    style={{ background: '#343c89' }}
                  >
                    Cambiar Contraseña
                  </Button>
                </Box>
              </Grid>
            </Grid>
          </form>
        )}
      </Paper>
    </Fade>
  );
};

// Función para mapear accessLevel a roleId
const getRoleIdFromAccessLevel = (accessLevel: number): string => {
  const role = RolesList.find((r) => r.level === accessLevel);
  return role ? role.id : 'Admin'; // Fallback a Admin
};

export const Profile = () => {
  const classes = Styles();
  const session = useTypedSelector((s) => s.session);
  const users = useTypedSelector((s) => s.users);
  const roleName = RolesList.find((w) => w.id === session.user?.role.name)?.name;
  const [editUser, setEditUser] = useState(false);
  const [editPassword, setEditPassword] = useState(false);
  const [modalActive, setModalActive] = useState(false);
  const [mounted, setMounted] = useState(false);
  const dispatch = useThunkDispatch();

  useEffect(() => {
    setMounted(true);
  }, []);

  const handleChangeSuccess = () => {
    setModalActive(true);
    handleReset();
  };

  const handleChangeEditUser = () => {
    setEditUser(true);
  };

  const handleChangeEditPassword = () => {
    setEditPassword(true);
  };

  const handleReset = () => {
    setEditUser(false);
    setEditPassword(false);
  };

  const handleClose = (event?: React.SyntheticEvent, reason?: string) => {
    if (reason === 'clickaway') {
      return;
    }
    setModalActive(false);
  };

  const handleActive = () => {
    setModalActive(true);
    handleReset();
  };

  if (session.isLoading) {
    return (
      <Box display="flex" justifyContent="center" alignItems="center" minHeight="60vh">
        <CircularProgress style={{ color: '#343c89' }} size={60} />
      </Box>
    );
  }

  return (
    <Container component="main" maxWidth="md" style={{ paddingTop: '40px', paddingBottom: '40px' }}>
      <Fade in={mounted} timeout={800}>
        <div>
          {!editUser && !editPassword ? (
            <Paper
              elevation={8}
              style={{
                padding: '40px',
                borderRadius: '16px',
                background: 'linear-gradient(135deg, #ffffff 0%, #f8f9fa 100%)',
                boxShadow: '0 8px 32px rgba(0, 0, 0, 0.1)',
              }}
            >
              <Box
                style={{
                  background: 'linear-gradient(135deg, #343c89 0%, #4a5aaa 100%)',
                  padding: '32px',
                  borderRadius: '12px',
                  marginBottom: '32px',
                  boxShadow: '0 4px 20px rgba(52, 60, 137, 0.2)',
                  position: 'relative',
                  overflow: 'hidden',
                }}
              >
                <Box display="flex" alignItems="center" flexDirection={{ xs: 'column', sm: 'row' }}>
                  <Box
                    sx={{
                      width: '100px',
                      height: '100px',
                      borderRadius: '50%',
                      bgcolor: 'rgba(255, 255, 255, 0.1)',
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                      marginRight: { xs: 0, sm: '24px' },
                      marginBottom: { xs: '16px', sm: 0 },
                      border: '3px solid rgba(255, 255, 255, 0.2)'
                    }}
                  >
                    <AccountCircle style={{ fontSize: '60px', color: 'white' }} />
                  </Box>
                  <Box textAlign={{ xs: 'center', sm: 'left' }}>
                    <Typography
                      variant="h4"
                      style={{
                        fontWeight: 700,
                        color: 'white',
                        marginBottom: '4px',
                        fontSize: '28px',
                      }}
                    >
                      {session.user.name} {session.user.lastName}
                    </Typography>
                    {roleName && (
                      <Typography
                        variant="subtitle1"
                        style={{
                          color: 'rgba(255, 255, 255, 0.9)',
                          fontWeight: 500,
                          fontSize: '18px',
                          marginBottom: '8px',
                        }}
                      >
                        {roleName}
                      </Typography>
                    )}
                    <Box
                      sx={{
                        color: 'rgba(255, 255, 255, 0.8)',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: { xs: 'center', sm: 'flex-start' },
                      }}
                    >
                      <Typography variant="body2" component="div">
                        <Box component="span" mr={1}>👤</Box>
                        {session.user.userName}
                      </Typography>
                    </Box>
                  </Box>
                </Box>
              </Box>

              <Grid container spacing={3} justifyContent="center">
                <Grid item xs={12} sm={6} md={5}>
                  <Card
                    elevation={3}
                    style={{
                      borderRadius: '12px',
                      height: '100%',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      cursor: 'pointer',
                    }}
                    onClick={handleChangeEditUser}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-4px)';
                      e.currentTarget.style.boxShadow = '0 8px 24px rgba(52, 60, 137, 0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)';
                    }}
                  >
                    <CardContent style={{ padding: '24px' }}>
                      <Box display="flex" alignItems="center">
                        <Box
                          style={{
                            backgroundColor: 'rgba(52, 60, 137, 0.1)',
                            borderRadius: '50%',
                            padding: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: '16px',
                          }}
                        >
                          <Person style={{ color: '#343c89', fontSize: '28px' }} />
                        </Box>
                        <Box>
                          <Typography variant="h6" style={{ color: '#343c89', fontWeight: 600 }}>
                            Editar Perfil
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            Actualiza tu información personal
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>

                <Grid item xs={12} sm={6} md={5}>
                  <Card
                    elevation={3}
                    style={{
                      borderRadius: '12px',
                      height: '100%',
                      transition: 'transform 0.3s ease, box-shadow 0.3s ease',
                      cursor: 'pointer',
                    }}
                    onClick={handleChangeEditPassword}
                    onMouseEnter={(e) => {
                      e.currentTarget.style.transform = 'translateY(-4px)';
                      e.currentTarget.style.boxShadow = '0 8px 24px rgba(14, 129, 75, 0.2)';
                    }}
                    onMouseLeave={(e) => {
                      e.currentTarget.style.transform = 'translateY(0)';
                      e.currentTarget.style.boxShadow = '0 1px 3px rgba(0,0,0,0.12), 0 1px 2px rgba(0,0,0,0.24)';
                    }}
                  >
                    <CardContent style={{ padding: '24px' }}>
                      <Box display="flex" alignItems="center">
                        <Box
                          style={{
                            backgroundColor: 'rgba(14, 129, 75, 0.1)',
                            borderRadius: '50%',
                            padding: '12px',
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            marginRight: '16px',
                          }}
                        >
                          <VpnKey style={{ color: '#0e814b', fontSize: '28px' }} />
                        </Box>
                        <Box>
                          <Typography variant="h6" style={{ color: '#0e814b', fontWeight: 600 }}>
                            Cambiar Contraseña
                          </Typography>
                          <Typography variant="body2" color="textSecondary">
                            Actualiza tu contraseña de acceso
                          </Typography>
                        </Box>
                      </Box>
                    </CardContent>
                  </Card>
                </Grid>
              </Grid>
            </Paper>
          ) : (
            <>
              {editUser ? (
                <EditProfile 
                  handleActive={handleActive} 
                  onBack={handleReset} 
                />
              ) : (
                <EditPassword
                  handleChangeSuccess={handleChangeSuccess}
                  handleActive={handleActive}
                  onBack={handleReset}
                />
              )}
            </>
          )}

          <Snackbar 
            open={modalActive} 
            autoHideDuration={6000} 
            onClose={handleClose}
            anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
          >
            <Alert 
              onClose={handleClose} 
              severity={session.error || users.error ? 'error' : 'success'}
              style={{ minWidth: '300px' }}
            >
              {session.error || users.error ? (
                <Typography variant="body2">
                  Ocurrió un error: {session.error?.message || users.error?.message}
                </Typography>
              ) : (
                <Typography variant="body2">
                  Los cambios se han guardado correctamente
                </Typography>
              )}
            </Alert>
          </Snackbar>
        </div>
      </Fade>
    </Container>
  );
};
